var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rs-text-field',_vm._g(_vm._b({attrs:{"clearable":!_vm.disabled,"label":_vm.label,"readonly":_vm.disabled,"filled":_vm.disabled && _vm.filledOnDisabled,"type":"date","min":_vm.min,"max":_vm.max}},'rs-text-field',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }